import { RESPONSE_TYPES } from "@root/constants";
import { HttpService } from "@services/http";
import {
  prepareErrorResponse,
  prepareResponseObject,
} from "@services/http/response";

export class ResourcesService extends HttpService {
  getResources = async (
    baseAuthUrl: string,
    payload: any
  ): Promise<IPrepareResponse<AxiosResponse>> => {
    try {
      const apiResponse = await this.get(
        `${baseAuthUrl}/api/resources`,
        payload
      );
      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
  deleteResource = async (
    baseAuthUrl: string,
    id: string
  ): Promise<IPrepareResponse<AxiosResponse>> => {
    try {
      const apiResponse = await this.delete(
        `${baseAuthUrl}/api/resources/${id}`,
        undefined
      );
      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
  addResource = async (
    baseAuthUrl: string,
    data: Record<string, TObject>
  ): Promise<IPrepareResponse<AxiosResponse>> => {
    try {
      const headers: TObject = {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      };
      const apiResponse = await this.post(`${baseAuthUrl}/api/resources`, data, { headers });

      return prepareResponseObject(apiResponse, RESPONSE_TYPES.SUCCESS);
    } catch (error) {
      return prepareErrorResponse(error);
    }
  };
}
